export default __webpack_public_path__ + "static/media/logo_tgv.6c434219.svg";